import React, { useEffect, useState } from "react";

const NEW_CATEGORY_VALUE = "__new__";
const emptyForm = { name: "", category: "", price: "", priceNote: "", isActive: true };

const ServiceCatalogFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  editingItem,
  isLoading = false,
  categories = [],
}) => {
  const [form, setForm] = useState(emptyForm);
  const [isNewCategory, setIsNewCategory] = useState(false);

  useEffect(() => {
    if (editingItem) {
      setForm({
        name: editingItem.name || "",
        category: editingItem.category || "",
        price: editingItem.price ?? "",
        priceNote: editingItem.priceNote || "",
        isActive: editingItem.isActive !== false,
      });
      setIsNewCategory(false);
    } else {
      setForm(emptyForm);
      setIsNewCategory(categories.length === 0);
    }
  }, [editingItem, isOpen, categories.length]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleCategorySelect = (e) => {
    const { value } = e.target;
    if (value === NEW_CATEGORY_VALUE) {
      setIsNewCategory(true);
      setForm((prev) => ({ ...prev, category: "" }));
    } else {
      setForm((prev) => ({ ...prev, category: value }));
    }
  };

  const handleClose = () => {
    setForm(emptyForm);
    setIsNewCategory(false);
    onClose();
  };

  const handleSubmit = () => {
    onSubmit({ ...form, category: form.category.trim() });
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: isOpen ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content shadow-lg border-0">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold fs-4">
              {editingItem ? "Edit Service" : "Add Service"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body py-4">
            <div className="mb-3">
              <label className="form-label fw-bold">Service Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={form.name}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Category</label>
              {!isNewCategory ? (
                <select
                  className="form-select"
                  value={form.category}
                  onChange={handleCategorySelect}
                >
                  <option value="">Select category</option>
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                  <option value={NEW_CATEGORY_VALUE}>+ Add new category</option>
                </select>
              ) : (
                <div className="d-flex gap-2">
                  <input
                    type="text"
                    name="category"
                    className="form-control"
                    value={form.category}
                    onChange={handleChange}
                    placeholder="New category name"
                    autoFocus
                  />
                  {categories.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-light-secondary"
                      onClick={() => {
                        setIsNewCategory(false);
                        setForm((prev) => ({ ...prev, category: "" }));
                      }}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-6 mb-3">
                <label className="form-label fw-bold">Starting Price ($)</label>
                <input
                  type="number"
                  step="any"
                  min="0"
                  name="price"
                  className="form-control"
                  value={form.price}
                  onChange={handleChange}
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label fw-bold">Price Note (optional)</label>
                <input
                  type="text"
                  name="priceNote"
                  className="form-control"
                  value={form.priceNote}
                  onChange={handleChange}
                  placeholder="e.g. $200-$400, Varies, Per gallon"
                />
              </div>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="isActiveCheck"
                name="isActive"
                checked={form.isActive}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="isActiveCheck">
                Active (shown when creating invoices)
              </label>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-light-secondary fw-bold"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary fw-bold"
              onClick={handleSubmit}
              disabled={isLoading || !form.name}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCatalogFormModal;
